export default "__VITE_ASSET__DoK3H7WB__"